/**
 * BankAgentPage — osobny ekran Agenta Wyciągów.
 *
 * Reusuje istniejący komponent `BankAgentTab` bez przepisywania logiki.
 * Dodaje breadcrumb / nagłówek + przycisk powrotu do listy wyciągów.
 */
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bot } from "lucide-react";
import { Button } from "@/components/ui/button";
import BankAgentTab from "./BankAgentTab";
import { usePageContainer } from "@/hooks/usePageContainer";

const BankAgentPage = () => {
  const navigate = useNavigate();
  // Pakiet 1: Agent Wyciągów pokazuje gęste listy — szerszy kontener.
  usePageContainer("wide");

  return (
    <div data-testid="bank-agent-page">
      <div className="mb-4 flex items-center gap-3">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate("/wyciagi")}
          data-testid="bank-agent-back-btn"
          className="text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft className="w-4 h-4 mr-1.5" />
          Wróć do Wyciągów
        </Button>
      </div>
      <header className="mb-5 flex items-start gap-3">
        <div className="p-2 bg-indigo-50 rounded-md">
          <Bot className="w-6 h-6 text-indigo-700" />
        </div>
        <div>
          <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">Agent Wyciągów</h1>
          <p className="text-sm text-gray-600 mt-1">
            Analiza historii transakcji bankowych i budowa profili płatniczych kontrahentów.
          </p>
        </div>
      </header>
      <BankAgentTab />
    </div>
  );
};

export default BankAgentPage;
